import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Common/Modal';
import Button from '../../Common/Button';
import common from '../../../common/common';
import styles from './index.module.scss';
import DOMPurify from 'dompurify';

function LexueNoticeModal({
  visible = false,
  title = '',
  content = '',
  confirmText = '我知道了',
  onCancel,
  onOk,
}) {
  const safeTitle = DOMPurify.sanitize(title);
  const safeContent = DOMPurify.sanitize(content);

  return (
    <Modal
      visible={visible}
      width={common.isPhone() ? 30 : 600}
      wrapClassName={styles.noticeModal}
      maskStyle={{ zIndex: 200000, pointerEvents: 'auto' }}
      title={<div className={styles.title} dangerouslySetInnerHTML={{ __html: safeTitle }} />}
      closable={true}
      footer={null}
      onCancel={onCancel}
    >
      <div className={styles.content} dangerouslySetInnerHTML={{ __html: safeContent }} />
      <div className={styles.footer}>
        <Button type="primary" onClick={onOk}>{confirmText}</Button>
      </div>
    </Modal>
  );
}

LexueNoticeModal.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.string,
  confirmText: PropTypes.string,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
};

export default LexueNoticeModal;
